import { DateTime } from "luxon";

/*
 * The timezone rules every departure picker shares.
 */

export const DEPARTURE = {
  DEFAULT: "DEFAULT",
  SCHEDULED: "SCHEDULED",
};

/* The shape a datetime-local input reads and writes. */
export const LOCAL_DATETIME = "yyyy-MM-dd'T'HH:mm";

/** An ISO instant -> the wall-clock string the input wants, in the venue's zone. */
export function toLocalInput(iso, tz) {
  if (!iso || !tz) return "";

  const dt = DateTime.fromISO(iso, { zone: tz });

  return dt.isValid ? dt.toFormat(LOCAL_DATETIME) : "";
}

/** What the input holds -> an ISO instant, read as venue wall-clock. */
export function fromLocalInput(local, tz) {
  if (!local || !tz) return null;

  const dt = DateTime.fromISO(local, { zone: tz });

  return dt.isValid ? dt.toISO() : null;
}

/** `now + minutes`, as the input's wall-clock string. */
export function localInputFromNow(tz, minutes = 0) {
  if (!tz) return "";

  return DateTime.now().setZone(tz).plus({ minutes }).toFormat(LOCAL_DATETIME);
}

/**
 * The picker's ceiling. A minute is shaved off because the server rejects a
 * departure *at* the expiry, not just past it - offering a time the write path
 * refuses is the bug this avoids.
 */
export function maxLocalInput(expiresAt, tz) {
  if (!expiresAt || !tz) return undefined;

  const dt = DateTime.fromISO(expiresAt, { zone: tz });

  return dt.isValid
    ? dt.minus({ minutes: 1 }).toFormat(LOCAL_DATETIME)
    : undefined;
}

/** Is a wall-clock value outside the bounds the card allows? */
export function isOutOfRange(local, { min, max }) {
  if (!local) return false;

  return Boolean((max && local > max) || (min && local < min));
}

/** Venue-local time of day, for copy like "we'll start bringing it at 4:00pm". */
export function formatDepartureTime(iso, tz) {
  if (!iso || !tz) return "";

  const dt = DateTime.fromISO(iso, { zone: tz });

  return dt.isValid ? dt.toFormat("h:mm a") : "";
}

/** Venue-local day + time, for rows that may be days away from now. */
export function formatDepartureDateTime(iso, tz) {
  if (!iso || !tz) return "";

  const dt = DateTime.fromISO(iso, { zone: tz });

  return dt.isValid ? dt.toFormat("h:mm a, ccc d LLL") : "";
}
